import styled from '@emotion/styled';
import { flex } from '@/common/styles';

export const Root = styled.div`
  ${flex({ alignment: 'center', justify: 'center' })}
  cursor: help;
`;
